import type { EditorConfig } from "./types";
import {
  Heading,
  Paragraph,
  Quote,
  Verse,
  Image,
  Gallery,
  Divider,
  Callout,
  Video,
  Embed,
  List,
  Code,
  Spacer,
  Button,
  Hero,
  TwoColumn,
  Stat,
  Cta,
  Table,
  Accordion,
  Columns,
  Audio,
  Pdf,
  Footnotes,
  Math,
  Row,
  registerRowSerialisers,
} from "./blocks";
import { LearningObjectives, KeyTerms, Exercise, InlineQuiz } from "./courseBlocks";

// Lessons share the whole block library with articles/documents, plus the
// course-specific pedagogy widgets. Adding a block here makes it available in
// every lesson at once — the centralized "reusable elements" the courses brief
// calls for.
const lessonBlockTypes = [
  Heading,
  Paragraph,
  List,
  Quote,
  Verse,
  Callout,
  LearningObjectives,
  KeyTerms,
  Exercise,
  InlineQuiz,
  Footnotes,
  Image,
  Gallery,
  Video,
  Audio,
  Pdf,
  Embed,
  Code,
  Math,
  Hero,
  TwoColumn,
  Columns,
  Row,
  Table,
  Accordion,
  Stat,
  Cta,
  Button,
  Divider,
  Spacer,
];

registerRowSerialisers(lessonBlockTypes);

export const lessonEditorConfig: EditorConfig = {
  blockTypes: lessonBlockTypes,
  paletteOrder: [
    "learning-objectives",
    "heading",
    "paragraph",
    "list",
    "key-terms",
    "verse",
    "callout",
    "exercise",
    "inline-quiz",
    "quote",
    "footnotes",
    "image",
    "gallery",
    "video",
    "audio",
    "pdf",
    "embed",
    "math",
    "code",
    "hero",
    "two-column",
    "columns",
    "table",
    "accordion",
    "stat",
    "cta",
    "button",
    "divider",
    "spacer",
  ],
};
